import React, { useState, useEffect } from 'react';

const WebcamImage = () => {
  const [timestamp, setTimestamp] = useState(Date.now());

  useEffect(() => {
    const updateTimestamp = () => setTimestamp(Date.now());

    const scheduleNextUpdate = () => {
      const now = new Date();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const milliseconds = now.getMilliseconds();

      const minutesToNext = 10 - (minutes % 10);
      const delayMs = (minutesToNext * 60 * 1000) - (seconds * 1000 + milliseconds);

      return setTimeout(() => {
        updateTimestamp();
        setInterval(updateTimestamp, 10 * 60 * 1000);
      }, delayMs);
    };

    const timeoutId = scheduleNextUpdate();

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <section className="webcam-section" style={{ marginTop: '2rem' }}>
      <img
        src={`https://skodjesbf.com/webcam/WebcamSSBF.jpg?ts=${timestamp}`}
        alt="Webkamera"
        className="webcam-image"
        style={{
          width: '100%',
          maxWidth: '600px',
          display: 'block',
          margin: '1rem auto'
        }}
      />
    </section>
  );
};

export default WebcamImage;
